import * as React from 'react'
import PropTypes from 'prop-types'
import Layout from '../layout'
import Header from '../header'
import Footer from '../footer'
import ContactUsForm from '../contact-us-form'
import TestimonialCarousel from '../testimonial-carousel'

function SharedLayout({ children }) {
  return (
    <Layout>
      <Header/>
      <main>{children}</main>
      <TestimonialCarousel />
      <ContactUsForm />
      <Footer />
    </Layout>
  )
}

SharedLayout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default SharedLayout
